export enum AudioSurahsFilterType {
  ALL,
  MOST_POPULAR,
  FAVORITE,
}
